var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input-text",class:{ block: _vm.block },style:(_vm.style),attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }